<h2 mat-dialog-title>{{ isAddMode ? 'Invite User' : 'Edit User' }}</h2>

<mat-dialog-content>
  <form [formGroup]="userForm">
    <mat-form-field *ngIf="!isAddMode" appearance="outline" style="width: 100%;">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name">
      <mat-error *ngIf="userForm.get('name')?.hasError('required')">Name is required</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!isAddMode" appearance="outline" style="width: 100%;">
      <mat-label>Surname</mat-label>
      <input matInput formControlName="surname">
      <mat-error *ngIf="userForm.get('surname')?.hasError('required')">Surname is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" type="email" [readonly]="!isAddMode">
      <mat-error *ngIf="userForm.get('email')?.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="userForm.get('email')?.hasError('email')">Invalid email format</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;" *ngIf="!isAddMode">
      <mat-label>ID Number</mat-label>
      <input matInput formControlName="idNumber" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;" *ngIf="!isAddMode">
      <mat-label>Company</mat-label>
      <input matInput formControlName="companyName" readonly>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role" (selectionChange)="onRoleChanged($event.value)">
        <mat-option value="user">User</mat-option>
        <mat-option value="admin">Admin</mat-option>
      </mat-select>
      <mat-error *ngIf="userForm.get('role')?.hasError('required')">Role is required</mat-error>
    </mat-form-field>

    <div *ngIf="isAdminRoleSelected" style="margin-bottom: 16px;">
      <mat-checkbox formControlName="isBillingOwner" color="primary">
        Is this account the team billing owner?
      </mat-checkbox>
    </div>

    <mat-form-field *ngIf="!isAddMode" appearance="outline" style="width: 100%;">
      <mat-label>Account Type</mat-label>
      <mat-select formControlName="team">
        <mat-option [value]="true">Team</mat-option>
        <mat-option [value]="false">Individual</mat-option>
      </mat-select>
      <mat-hint>Team users are billed on team tier; individual users use individual plans.</mat-hint>
    </mat-form-field>

    <div *ngIf="isAddMode" style="margin-bottom: 16px;">
      <div style="font-size: 14px; font-weight: 500; margin-bottom: 8px;">Invite As:</div>
      <mat-radio-group formControlName="inviteAs">
        <mat-radio-button value="team_member" color="primary" style="display: block; margin-bottom: 8px;">
          Team Member
        </mat-radio-button>
        <mat-radio-button value="individual" color="primary" style="display: block;">
          Individual
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="feature-flags-section" *ngIf="!isAddMode">
      <h3>Security</h3>
      <mat-checkbox formControlName="twoFactorEnabled" color="primary">
        Two-factor authentication
      </mat-checkbox>
    </div>

    <div class="feature-flags-section" *ngIf="!isAddMode || showEnableTrial">
      <h3>Billing</h3>
      <ng-container *ngIf="!isAddMode">
        <mat-checkbox formControlName="billingSeatExempt" color="primary">
          Seat exempt
        </mat-checkbox>
        <div style="font-size: 12px; color: var(--tbds-text-muted); margin-top: 4px; margin-bottom: 12px;">
          Exclude this user from team seat billing. Product features are managed on the Feature Flags page.
        </div>
      </ng-container>
      <mat-checkbox *ngIf="showEnableTrial" formControlName="enableTrial" color="primary">
        Enable Trial
      </mat-checkbox>
      <div *ngIf="showEnableTrial" style="font-size: 12px; color: var(--tbds-text-muted); margin-top: 4px;">
        Trial: no payment and 50 credits/month
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isSubmitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="userForm.invalid || isSubmitting">
    {{ isSubmitting ? 'Saving...' : (isAddMode ? 'Invite' : 'Update') }}
  </button>
</mat-dialog-actions>
